import React, { Component } from "react";
import "./SampleDL.scss";
import DLFront from "../../../assets/docSampleImages/DL FRONT.jpg";
import DLBACK from "../../../assets/docSampleImages/DL BACK.jpg";
export interface IViewSampleDLPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
}
const SampleDrivingLicensePopup = (props: IViewSampleDLPopup) => {
  const popupRefThree = React.useRef(null);
  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        popupRefThree.current !== null &&
        popupRefThree.current !== undefined
      ) {
        props?.setShowPopup(); // Close popup if clicked outside
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);

  return (
    <div
      className={`overlay-DL ${props?.parentClassName ?? ""}`}
      ref={popupRefThree}
    >
      <div className="popup-DL">
        {/* Close Button */}
        <button
          className="close-btn"
          onClick={(e) => {
            if (props?.setShowPopup !== undefined) props?.setShowPopup(false);
          }}
        >
          <i className="edel-icon-close" />
        </button>

        <h2 className="popup-title">Uploading Driving Licence</h2>

        {/* Popup Content */}
        {/* {commonUIView()} */}

        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Driving Licence in
              JPEG or PNG (Max Size: 2MB)
            </p>
            <span className="Aadhar-Front-row">
              <div className="image-container">
                <img
                  src={DLFront}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                />
                <div className="badge">1</div>
              </div>

              <label className="Aadhar-Label">FRONT</label>
            </span>
            <span className="Aadhar-Front-row mt-20">
              <div className="image-container">
                <img
                  src={DLBACK}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                />
                <div className="badge">2</div>
              </div>

              <label className="Aadhar-Label">BACK</label>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
export default SampleDrivingLicensePopup;
